import AsyncStorage from '@react-native-async-storage/async-storage';
import Toast2 from '@mmt/legacy-commons/Common/Components/Toast2';
import { fetchConfig, getCachedConfig, getDefaultConfig } from './vernacularRepository';
import {
  AbConfigKeyMappings,
  getPokusConfigWaitingPromise,
} from '@mmt/legacy-commons/Native/AbConfig/AbConfigModule';
import { actionResetRailLandingOnLangChange } from '../pages/RailsLandingPage/Store/RailsLandingPageActions';
import { getQueryParamsFromUrl } from '@mmt/legacy-commons/Helpers/misc';
import {
  RAILS_LANDING_VISIT_NUMBER,
  setDataInStorage,
  getDataFromStorage,
} from '@mmt/legacy-commons/AppState/LocalStorage';
import { getPokusConfig } from '@mmt/legacy-commons/Native/AbConfig/AbConfigModule';
import { PokusLobs } from '@mmt/legacy-commons/Native/AbConfig/AbConfigKeyMappings';
import { isClientRender } from '../Utils/CommonUtils';
import { isMweb } from '../Utils/device';
import initLanguage from './AppLanguage';
import { Platform } from 'react-native';

export const ACTION_SET_VERNACULAR_CONFIG = '@rails/ACTION_SET_VERNACULAR_CONFIG';
export const ACTION_SET_ENABLE_VERNACULAR = '@rails/ACTION_SET_ENABLE_VERNACULAR';
export const ACTION_SET_AVAILABLE_LANGUAGES = '@rails/ACTION_SET_AVAILABLE_LANGUAGES';
export const ACTION_TOGGLE_SHOW_LANGUAGE_PICKER = '@rails/ACTION_TOGGLE_SHOW_LANGUAGE_PICKER';
export const ACTION_SET_CURRENT_LANGUAGE = '@rails/ACTION_SET_CURRENT_LANGUAGE';
export const ACTION_REFRESH_PAGE_LANGUAGE = "@rails/ACTION_REFRESH_PAGE_LANGUAGE";
export const ACTION_SHOW_FETCHING_TRANSLATION_LOADER =
  '@rails/ACTION_SHOW_FETCHING_TRANSLATION_LOADER';

export const actionRefreshPageLanguage  = () => async (dispatch) => {
  dispatch({
        type : ACTION_REFRESH_PAGE_LANGUAGE
    });
}
// export const initVernacular = (lang) => async (dispatch) => {
//   let config,queryLang,urlLang;
//   try {
//     config = await getCachedConfig();
//   } catch (e) {
//     config = getDefaultConfig();
//   }
//   let queryParams;
//   if (isClientRender() && isMweb()) {
//     queryParams = getQueryParamsFromUrl(window.location.href);
//   }
//   if (isClientRender() && isMweb() && queryParams['lang']) {
//     queryLang = queryParams['lang'];
//     urlLang = config.availableLanguages.find((x) => x.code === queryLang);
//     config.selectedLanguage = urlLang ? urlLang : config.selectedLanguage;
//   } else if (lang) {
//     urlLang = config.availableLanguages.find((x) => x.code === lang);
//     config.selectedLanguage = urlLang ? urlLang : config.selectedLanguage;
//   }
//   try {
//     await getPokusConfigWaitingPromise();
//   } catch (e) {
//     console.log(e);
//   }
//   const railsEnableVernacular = getPokusConfig(
//     PokusLobs.RAIL,
//     AbConfigKeyMappings.railsEnableVernacular,
//     false,
//   );
//   // VERNAC TODO
//   if (!railsEnableVernacular) {
//     // const data = {...getDefaultConfig()}
//     // dispatch({
//     //   type: ACTION_SET_VERNACULAR_CONFIG,
//     //   data,
//     // });
//   }
//   else{
//     // const data = {...config,...{ disableVernacular: !railsEnableVernacular }}
//     // dispatch({
//     //   type: ACTION_SET_VERNACULAR_CONFIG,
//     //   data,
//     // });
//   }
//   let visit = Number(await getDataFromStorage(RAILS_LANDING_VISIT_NUMBER));
//   if (visit % 10 == 0) {
//     dispatch({
//       type: ACTION_TOGGLE_SHOW_LANGUAGE_PICKER,
//       data: true,
//     });
//   }
//   visit++;
//   setDataInStorage(RAILS_LANDING_VISIT_NUMBER, visit);

//   // setTimeout(async () => {
//   //   try {
//   //     const updatedConfig = await fetchConfig(config.selectedLanguage.code);
//   //     const data = {...updatedConfig,...{ disableVernacular: !railsEnableVernacular }}
//   //     dispatch({
//   //       type: ACTION_SET_VERNACULAR_CONFIG,
//   //       data,
//   //     });
//   //   } catch (e) {
//   //     logAction('error while updating translations');
//   //   }
//   // });
// };

export const actionShowLanguagePicker = {
  type: ACTION_TOGGLE_SHOW_LANGUAGE_PICKER,
  data: true,
};

export const actionHideLanguagePicker = {
  type: ACTION_TOGGLE_SHOW_LANGUAGE_PICKER,
  data: false,
};

export const actionSaveAndSetSelectLanguage = (selectedLanguage) => (dispatch) => {
  AsyncStorage.setItem('rails_current_language_code', selectedLanguage.code);
  actionSetSelectLanguage(selectedLanguage)(dispatch);
  actionResetRailLandingOnLangChange(dispatch);
};

// export const actionSetSelectLanguage = (selectedLanguage, updateTranslations = false) => async (
//   dispatch,
// ) => {
//   dispatch({
//     type: ACTION_SHOW_FETCHING_TRANSLATION_LOADER,
//     data: true,
//   });

//   try {
//     const configData = await fetchConfig(selectedLanguage.code);
//     if (!configData || configData.status !== 'SUCCESS') {
//       Toast2.show('Something went wrong!!');
//       return;
//     }
//     const { translations } = configData;

//     Toast2.show(`Changed language to ${selectedLanguage.name}`);

//     // dispatch({
//     //   type: ACTION_SET_CURRENT_LANGUAGE,
//     //   data: {
//     //     selectedLanguage,
//     //     translations,
//     //   },
//     // });
//   } finally {
//     dispatch({
//       type: ACTION_SHOW_FETCHING_TRANSLATION_LOADER,
//       data: false,
//     });
//   }
// };

// const updateLanguageTranslations = (langCode, translations) => (dispatch, getState) => {
//   const {
//     railsVernacular: { selectedLanguage },
//   } = getState();
//   // Race condition check
//   if (selectedLanguage.code !== langCode) {
//     return;
//   }
//   // dispatch({
//   //   type: ACTION_SET_CURRENT_LANGUAGE,
//   //   data: {
//   //     selectedLanguage,
//   //     translations,
//   //   },
//   // });
// };

export const updateRailsLang = (lang) => {
  return (dispatch) => {
    dispatch(setVernacularStatus({
      language: lang,
      status: "IN_PROGRESS"   // TODO Vernac
    }))
    if(Platform.OS !== 'web'){
      initLanguage(lang).then((data) => {
        dispatch(setVernacularStatus({
          language: lang,
          status: "DONE"   // TODO Vernac
        }))
      })
    }
  }
}

export const _updateRailsLang = (lang) => ({
  type: ACTION_SET_CURRENT_LANGUAGE,
  payload: {
    lang,
  }
});

export const setVernacularStatus = ({
  language,
  status
}) => {
  return {
    // TODO Vernac refactor/constant
    type: "@rails/SET_VERNACULAR_STATUS",
    payload: {
      language,
      status,
    }
  }
}
